import { Component } from '@verndale/core';
import SlimSelectComponent from '../components/slim-select';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.id;

    this.dom = {
      $form: this.el.getElementsByTagName('form')[0],
      $select: this.el._$$('select')
    };

    this.setup();
  }

  setup() {
    const $style = this.el.getElementsByTagName('style')[0];
    if ($style) $style.remove();
    let $iframe;

    try {
      $iframe = document.createElement(
        `<iframe name=${id} style="display: none">`
      );
    } catch (ex) {
      $iframe = document.createElement('iframe');
    }

    const id = `eloqua-submit-${this.id}`;
    $iframe.name = id;
    $iframe.style.display = 'none';
    this.el.appendChild($iframe);

    if (this.dom.$form) this.dom.$form.target = id;

    this.dom.$select.forEach(dropdown => new SlimSelectComponent(dropdown));
  }
}

export default Module;

export const isValid = $form => {
  if ($form._$$('.LV_invalid_field').length) {
    return false;
  }

  return true;
};
